import SvgLogo from "./Logo";
import SvgLogoBlack from "./LogoBlack";

export {
    SvgLogo,
    SvgLogoBlack,
};
